import { axiosLabAPI } from 'services/axios';
import { API_POST_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

/**
 * Checks if an integration code is already in use.
 * @param {string} code - The integration code to validate
 * @returns {Promise<Array|null>} - List of matches or null on error.
 */
export async function checkIntegrationCode(code) {
	const url = 'settings/intgrationcodecheck';
	try {
		const response = await axiosLabAPI({
			method: API_POST_METHOD,
			url,
			data: {
				p_code: code,
			},
		});

		const { data } = await response;
		return data.RECORDS || [];
	} catch (e) {
		showMessage(e);
		return null;
	}
}
